<div class="row my-row">

    <aside class="col-md-3 my-col" id="sticky-sidebar">
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">

        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
    
        <app-open-message *ngIf="message" [message]="message" [ref]="ref"></app-open-message>
        
    </div> 

</div>
